// @ts-ignore
import React from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import Lozenge from "@atlaskit/lozenge";
import { media } from "@atlaskit/primitives/responsive";

import { JswInteractiveRoadmap } from "@/components/jsw-interactive-roadmap/src";
import WplButton from "@/components/wpl/button/src";
import { useLocalizedHref } from "@/libraries/web-framework";

export type FeatureFlags = {
    readonly provisionSecondPartyApps?: boolean;
    readonly enableBundlesAfterSignup?: boolean;
};

const RoadmapContainerStyle = css({
    padding: "16px",
    margin: "0 auto",
    display: "flex",
    justifyContent: "center"
});

const headers = css({
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "1rem",

    margin: "0 auto",
    [media.below.sm]: {
        width: "100%"
    },
    [media.above.sm]: {
        width: "66.66%"
    }
});

const h6Styles = css({
    color: "#42526e",
    fontSize: ".75rem",
    letterSpacing: "1px",
    lineHeight: "2",
    marginBlockStart: "0",
    marginBlockEnd: "10px",
    textTransform: "uppercase",
    fontWeight: "400"
});

const h2Styles = css({
    "display": "block",
    "textAlign": "center",
    "color": "#253858",
    "letterSpacing": "0",
    "marginBlockStart": "0",
    "fontWeight": "500",
    "verticalAlign": "middle",

    [media.below.md]: {
        marginBlockEnd: "14px"
    },
    [media.above.md]: {
        marginBlockEnd: "24px"
    },

    "@media (min-width: 768px)": {
        fontSize: "2.25rem",
        lineHeight: "1.33333333"
    },
    "& span": { verticalAlign: "middle" }
});

const pStyle = css({
    fontSize: "1rem",
    textAlign: "center",
    marginBlockEnd: "24px",
    marginBlockStart: "0",
    justifyContent: "center"
});

const ContainerStyle = css({
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    alignSelf: "center",

    [media.below.md]: {
        padding: "16px 0"
    },
    [media.above.md]: {
        paddingBlockStart: "8px",
        paddingBlockEnd: "64px"
    }
});

const Timeline = () => {
    const intl = useIntl();
    return (
        <div css={ContainerStyle}>
            <div css={headers}>
                <h6 css={h6Styles}>
                    {intl.formatMessage({
                        defaultMessage: "Plan ahead, pivot quickly",
                        id: "JSWFeaturesTimeline.subheader"
                    })}
                </h6>
                <h2 css={h2Styles}>
                    {intl.formatMessage({
                        defaultMessage: "Timelines",
                        id: "JSWFeaturesTimeline.title"
                    })}
                    <div css={css({ width: "5px", display: "inline-block" })} />
                    <Lozenge appearance={"inprogress"} isBold={false}>
                        {intl.formatMessage({
                            defaultMessage: "Try it",
                            id: "JSWFeaturesTimeline.tryIt"
                        })}
                    </Lozenge>
                </h2>
                <div>
                    <p css={pStyle}>
                        {intl.formatMessage({
                            id: "JSWFeaturesTimeline.description",
                            defaultMessage: `Use the interactive timeline to try adding epics, mapping work items, dependencies, and releases on a timeline. Timelines keep your teams and stakeholders in sync.`
                        })}
                    </p>
                </div>
                <div>
                    <WplButton
                        text={intl.formatMessage({
                            id: "JSWFeaturesTimeline.learnMore",
                            defaultMessage: "Learn more"
                        })}
                        url={useLocalizedHref(
                            "/software/jira/features/roadmaps"
                        )}
                        size={"small"}
                        type={"secondary"}
                        css={css({ display: "inline-flex" })}
                        dataEventProps={{
                            "data-product-key": "jiraSoftwareFeature",
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "timelineSection"
                        }}
                    />
                </div>
            </div>
            <div css={RoadmapContainerStyle}>
                <JswInteractiveRoadmap />
            </div>
        </div>
    );
};

export default Timeline;
